export enum windowSizeQueries {
	small = 'screen',
	medium = 'screen and (min-width: 800px)',
	large = 'screen and (min-width: 1200px)',
	xlarge = 'screen and (min-width: 9999999px)', // Not used but leaving in for possible future use for non-brands
	xxlarge = 'screen and (min-width: 9999999px)', // Not used but leaving in for possible future use for non-brands
}

export function getWindowSize(): string {
	if (window.matchMedia(windowSizeQueries.xxlarge).matches) {
		return 'xxlarge'
	} else if (window.matchMedia(windowSizeQueries.xlarge).matches) {
		return 'xlarge'
	} else if (window.matchMedia(windowSizeQueries.large).matches) {
		return 'large'
	} else if (window.matchMedia(windowSizeQueries.medium).matches) {
		return 'medium'
	}

	return 'small'
}

/**
 * Determine if an element is in the vertical area of the viewport
 * Used priarily for lazy loading to determine when something is scrolled into
 * view so action can be taken (ie add an animation)
 * @param {object} el HTMLElement object
 * @returns {boolean}
 */
export function isVerticallyInViewport(el: HTMLElement): boolean {
	const win = {
		h: window.innerHeight,
		w: window.innerWidth,
	}

	if (el) {
		const box = el.getBoundingClientRect()
		const topEdgeInRange = box.top >= 0 && box.top <= win.h
		const bottomEdgeInRange = box.bottom >= 0 && box.bottom <= win.h

		return !!(topEdgeInRange || bottomEdgeInRange || (box.height >= win.h && box.top < 0 && box.bottom > 0))
	} else {
		return false
	}
}
